import { makeStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: 0,
    margin: 0,
    width: '100vw',
    height: '100vh',
    display: 'flex',
  },
  gridContainer: {
    margin: 0,
    padding: 0,
    height: '100%',
  },
  gridItem: {
    padding: 0,
    margin: 0,
    height: '100%',
    position: 'relative',
  },
  image: {
    height: '100%',
    width: '100%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    filter: 'blur(2px)',
    transition: 'filter 0.5s ease',
    '&:hover': {
      filter: 'blur(0px)',
    },
  },
  buttonContainer: {
    position: 'absolute',
    top: '80%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  button: {
    color: 'white',
    background: 'linear-gradient(90deg, rgba(2,203,244,1) 59%, rgba(0,153,235,1) 100%)',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.3)',
    '&:hover': {
      background: 'linear-gradient(90deg, rgba(2,203,244,1) 59%, rgba(0,153,235,1) 100%)',
      boxShadow: '0px 6px 8px rgba(0, 0, 0, 0.4)',
      transform: 'scale(1.10)',
    },
    textTransform: 'none',
    fontSize: '1.25rem',
    padding: '1px 20px',
    borderRadius: '8px',
    minWidth: '200px',
    height: 'auto',
  },
}));
